import xhrService from '../api';
import { apiError } from '../apiError';

export interface Division {
  id: number;
  name: string;
  createdAt?: Date;
}
export const regionApi = {
  index: () => {
    return xhrService
      .get(`/api/regions`)
      .then((res) => res.data)
      .catch((err) => {
        throw apiError(err);
      });
  },
  create: (body: {}) => {
    return xhrService
      .post('/api/regions', body)
      .then((res) => res.data)
      .catch((err) => {
        throw apiError(err);
      });
  },
  update: (regionId: number, body: {}) => {
    return xhrService
      .put(`/api/regions/${regionId}`, body)
      .then((res) => res.data)
      .catch((err) => {
        throw apiError(err);
      });
  },
  delete: (regionId: number) => {
    return xhrService
      .delete(`/api/regions/${regionId}`)
      .then((res) => res.data)
      .catch((err) => {
        throw apiError(err);
      });
  },
  divisions: {
    index(regionId: number): Promise<Division[]> {
      return xhrService
        .get(`/api/regions/${regionId}/divisions`)
        .then((res) => res.data);
    },
  },
};
